import EnvironmentHelper from '../EnvironmentHelper';
import { type Environment } from '../../constants';

const VES_STREAM_SERVICE_URL_BLEEDING_EDGE = 'https://bleeding-edge-video.dev.bombbomb.io';
const VES_STREAM_SERVICE_URL_LOCALHOST = 'http://localhost:8082';

/**
 * Generates environment-specific VES URL and env and allows overriding them in localhost.
 */
export class VesData {
  protected environment: Uppercase<Environment>;

  public baseUrl: string;

  public requestEnv: string;

  constructor(environment: Environment, forceBleedingEdgeVES = false, forceLocalhostVES = false) {
    this.environment = environment.toUpperCase() as Uppercase<Environment>;

    /**
     * Need to set the environment again because for some reason it's not set here like it might be
     * in the client code that's calling this.
     */
    EnvironmentHelper.setEnvironment(environment);
    // get the default stream url and request environment from the environment config
    const { ves } = EnvironmentHelper.getEnvironmentConfig();
    this.baseUrl = ves.baseUrl;
    this.requestEnv = ves.saveEnvironment;

    // prevent bleeding-edge/localhost VES configurations if not local environment
    const shouldForceBleedingEdgeVES = this.environment === 'LOCAL' && forceBleedingEdgeVES;
    const shouldForceLocalhostVES = this.environment === 'LOCAL' && forceLocalhostVES;

    if (shouldForceBleedingEdgeVES) {
      this.baseUrl = VES_STREAM_SERVICE_URL_BLEEDING_EDGE;
      this.environment = 'LOCAL';
      this.requestEnv = 'DEV';
    }

    // Localhost VES override takes priority over bleeding edge VES override
    if (shouldForceLocalhostVES) {
      // Http localhost allows recording to work in Chrome
      this.baseUrl = VES_STREAM_SERVICE_URL_LOCALHOST;
      // https localhost with ngrok makes recording work in Safari
      // this.baseUrl = 'https://<insertYourUrlHere>.ngrok-free.app';
      this.environment = 'LOCAL';
      this.requestEnv = 'LOCAL';
    }
  }

  static get createVideoRecordingPath() {
    return 'createVideoRecording';
  }

  static get createRawChunkUploadPreSignedUrlsPath() {
    return 'createRawChunkUploadPreSignedUrls';
  }

  static get completeVideoRecordingPath() {
    return 'completeVideoRecording';
  }

  get eagerlyCompleteVideoRecordingSocketUrl() {
    return `${this.baseUrl}/eagerlyCompleteVideoRecording`;
  }
}
